import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../redux/profile/action";
import { useStateContext } from "../../../Context/StateContext";
import Notifications from "../../Modules/Notifications/Notifications";
import { getNotificationcount } from "../../../redux/chatandnotification/action";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import { isThisMobileScreen } from "../../../assests/extention/commonfunction";
import CreateServiceModal from "./CreateServiceModal";
import LogoutModel from "./LogoutModel";
import ProfileModel from "./ProfileModel";
import whatsappIcon from "../../../assests/imgs/whatsapp-icon.svg"
import { getSettings } from "../../../redux/Contacts/action";

export default function PrivateHeader() {
  const [modal, setModal] = useState(false);
  const [manu, setmanu] = useState(false);
  const [onhover1, setOnhover1] = useState(false);
  const [onhover2, setOnhover2] = useState(false);
  const [onhover3, setOnhover3] = useState(false);
  const [onhover4, setOnhover4] = useState(false);
  const [onhover5, setOnhover5] = useState(false);
  const [onhover6, setOnhover6] = useState(false);
  const [onhover7, setOnhover7] = useState(false);
  const [createProjectModal, setCreateProjectModal] = useState(false);
  const [notificationcount, setNotificationcount] = useState(0);
  const [showdashboard, setShowdashboard] = useState(false);
  const { setState, clearAllFields, setAllpostfiltertab } = useStateContext();
  const { setOTSroute, setOTSAutoOpen } = useRouteBaseStateContext();

  const { t, i18n } = useTranslation();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const lans = [
    { name: "العربية", code: "ar", dir: "rtl" },
    { name: "English", code: "en", dir: "lrt" },
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  const theSettingDetails = useSelector(
    ({ settingsDetails: { settingList } }) => settingList || {}
  );

  const {
    whatsapp_call,
  } = theSettingDetails;

  const whatsAppHref = whatsapp_call
    ? `https://wa.me/${whatsapp_call}?text=${encodeURIComponent('Hello I need assistance.')}`
    : '#';

  const path = "Assets/scss/header.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  const notificationCount = useSelector(({ chatandnotification: { getnotificationcount } }) => getnotificationcount);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    dispatch(getNotificationcount());
    const interval = setInterval(() => {
      dispatch(getNotificationcount());
    }, 5000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const ncount = useSelector(({ chatandnotification: { getnotificationcount } }) => getnotificationcount);

  useEffect(() => {
    const notifications = parseInt(ncount?.notification, 10) || 0;
    const invites = parseInt(ncount?.invites, 10) || 0;
    const mentions = parseInt(ncount?.mentions, 10) || 0;
    const join_requests = parseInt(ncount?.join_requests, 10) || 0;

    const totalCount = notifications + invites + mentions + join_requests;
    setNotificationcount((prev) => (prev !== totalCount ? totalCount : prev));
  }, [ncount]);

  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // ───────────── MODAL LOGIC ─────────────
  const modalContentRefs = {
    logout: useRef(null),
    createProject: useRef(null),
  };

  const [activeModal, setActiveModal] = useState(null);
  const isMobile = window.innerWidth <= 1200;

  // Mobile navigation handler that closes header
  const handleMobileNavigation = (path, options = {}) => {
    if (isMobile) {
      setmanu(false); // Close the header menu
      setOpenDropdown(null); // Close any open dropdowns
      setActiveModal(null); // Close any open modals
    }
    navigate(path, options);
  };

  const handleModalToggle = (modalName) => {
    if (isMobile) {
      setActiveModal(activeModal == modalName ? null : modalName);
    } else {
      // Desktop behavior - use original state
      if (modalName == 'logout') {
        setModal(!modal);
      } else if (modalName == 'createProject') {
        setCreateProjectModal(!createProjectModal);
      }
    }
  };

  // Handle modal state sync for mobile
  useEffect(() => {
    if (isMobile) {
      if (activeModal == 'logout') {
        setModal(true);
      } else if (!activeModal) {
        setModal(false);
      }
    }
  }, [activeModal, isMobile]);

  useEffect(() => {
    if (isMobile) {
      if (activeModal == 'createProject') {
        setCreateProjectModal(true);
      } else if (!activeModal) {
        setCreateProjectModal(false);
      }
    }
  }, [activeModal, isMobile]);

  // Handle outside click for mobile
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!isMobile) return;

      let clickedInside = false;

      // Check dropdown refs
      Object.keys(dropdownRefs).forEach((key) => {
        if (dropdownRefs[key].current?.contains(e.target)) {
          clickedInside = true;
        }
      });

      // Check modal content refs (the actual modal content, not the Modal component)
      Object.keys(modalContentRefs).forEach((key) => {
        if (modalContentRefs[key].current?.contains(e.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        setOpenDropdown(null);
        setActiveModal(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isMobile]);

  // ───────────── DROPDOWN LOGIC ─────────────
  const dropdownRefs = {
    onhover1: useRef(null),
    onhover2: useRef(null),
    onhover3: useRef(null),
    onhover4: useRef(null),
    onhover5: useRef(null),
    onhover6: useRef(null),
    onhover7: useRef(null),
  };
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownClick = (name) => {
    if (isMobile) setOpenDropdown(openDropdown == name ? null : name);
  };

  const LogoutMethod = () => {
    localStorage.removeItem("urexperttoken");
    localStorage.removeItem("role_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("urlState");
    localStorage.removeItem("OTS_ADD_DRAFT");
    localStorage.removeItem("BSA_ADD_DRAFT");
    localStorage.removeItem("BSM_ADD_DRAFT");
    localStorage.removeItem("TAI_ADD_DRAFT");
    localStorage.removeItem("MAS_ADD_DRAFT");
    dispatch(getProfile());
    handleMobileNavigation(`/${lan}/`);
    window.location.reload()
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (location.pathname.includes("dashboard")) {
      setShowdashboard(true);
    } else {
      setShowdashboard(false);
    }
  }, [location]);

  const currentLangObj = lans.find((lang) => lang.code == lan);

  useEffect(() => {
    window.scrollTo(0, 0);
    {
      lan == "ar"
        ? document.body.classList.add("arabic")
        : document.body.classList.remove("arabic");
    }
    i18n.changeLanguage(currentLangObj.code);
    {
      lan == "ar"
        ? (document.title = t("Ar URExpert"))
        : (document.title = t("EN URExpert"));
    }
  }, [lan]);

  const navigatetopostpage = (type) => {
    let sortposttype = [];

    switch (type) {
      case 1:
        sortposttype = [{ id: 1, title: "Post & Browse Projects (PBP)" }];
        break;
      case 2:
        sortposttype = [{ id: 2, title: "Win business Opportunities (WBO)" }];
        break;
      case 3:
        sortposttype = [{ id: 3, title: "Find Part time Job (PTJ)" }];
        break;
      case 4:
        sortposttype = [{ id: 3, title: "Part time Job (PTJ) you Applied" }];
        break;
      default:
        break;
    }

    setState((prevState) => ({
      ...prevState,
      sortByTime: "",
      sortlan: "",
      sortposttype: sortposttype,
      locationType: [],
      searchlocation: "",
      location: "",
      remoteChecked: false,
      onSiteChecked: false,
      keywords: [],
      specialities: [],
      industries: [],
      subcategories: [],
      experienceLevel: "",
      minHourlyRate: "",
      maxHourlyRate: "",
      proposed: type == 4 ? 1 : "",
      viewed: "",
      wishlist: "",
      allpostfiltertab: type == 4 ? "appliedpost" : "allpost",
    }));

    setOnhover2(false);
    handleMobileNavigation(`/${lan || "en"}/searchall?type=${type}`);
  };

  useEffect(() => {
    updatedURL(location.pathname, lan);
  }, [lan]);

  const updatedURL = (url, lang) => {
    if (lang == "ar" && url.includes("/en/")) {
      return url.replace("/en/", "/");
    } else if (lang == "ar" && url.includes("/en")) {
      return url.replace("/en", "/");
    } else {
      return lang == "en" && url.replace("/", "/en/");
    }
  };

  const NavigateToCreate = (path, thetype) => {
    handleMobileNavigation(`/${lan}/${path}`, { state: { theType: thetype ?? "" } });
    setCreateProjectModal(false);
    setActiveModal(null);
  };

  // Combined handlers for desktop hover and mobile click
  const handleNavItemInteraction = (name, isHover) => {
    if (isMobile) {
      handleDropdownClick(name);
    } else {
      // Desktop hover logic
      switch (name) {
        case 'onhover1': setOnhover1(isHover); break;
        case 'onhover2': setOnhover2(isHover); break;
        case 'onhover3': setOnhover3(isHover); break;
        case 'onhover4': setOnhover4(isHover); break;
        case 'onhover5': setOnhover5(isHover); break;
        case 'onhover6': setOnhover6(isHover); break;
        case 'onhover7': setOnhover7(isHover); break;
        default: break;
      }
    }
  };

  // Helper function to get modal toggle handler
  const getModalToggleHandler = (modalName) => {
    return () => handleModalToggle(modalName);
  };

  // Handle dropdown button click for mobile
  const handleDropdownButtonClick = (dropdownName) => {
    if (isMobile) {
      handleDropdownClick(dropdownName);
    }
  };

  return (
    <>
      <div className="col-md-12 header">
        <div className="row header-row">
          <div className="logo">
            <a onClick={() => { handleMobileNavigation(`/${lan}/account`); }}>
              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/logo.svg`} alt="" />
            </a>
          </div>
          <div className="menu-btn">
            <button onClick={() => setmanu(true)}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={manu ? "col-md-10 header-mobile active" : "col-md-10 header-mobile"} >
            <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
              {showdashboard ? (
                <div>
                  <h4 className="dashboard-head">
                    <img src={`${CloudStorage.cloudurl}/Assets/Images/common/dashboard-icon.svg`} /> {t("Dashboard")}
                  </h4>
                </div>
              ) : (
                <ul className="menu">
                  <li
                    ref={dropdownRefs.onhover1}
                    className={(isMobile ? openDropdown == 'onhover1' : onhover1) ? "active" : ""}
                    onClick={() => handleNavItemInteraction('onhover1', false)}
                    onMouseEnter={() => handleNavItemInteraction('onhover1', true)}
                    onMouseLeave={() => handleNavItemInteraction('onhover1', false)}
                  >
                    <a className="nav-item">{t("Find experts")}
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} />
                    </a>
                    {/* {onhover1 && <> */}

                    <div className="nav-drop">
                      <a onClick={() => handleMobileNavigation(`/${lan}/hireexpertsmainpage`)}>{t("Find Expert / Company")}</a>
                      {profile?.role_type == 1 || profile?.role_type == 2 ? (<a onClick={() => handleMobileNavigation(`/${lan}/registration`)}>  {t("Became A Company / Expert")}</a>) : ("")}
                      <button onClick={getModalToggleHandler('createProject')} className="btn"
                      ><img src={`${CloudStorage.cloudurl}/Assets/Images/common/plus.svg`} />  {t("Create a post")}
                      </button>
                    </div>
                    {/* </>} */}
                  </li>
                  <li
                    ref={dropdownRefs.onhover2}
                    className={(isMobile ? openDropdown == 'onhover2' : onhover2) ? "active" : ""}
                    onClick={() => handleNavItemInteraction('onhover2', false)}
                    onMouseEnter={() => handleNavItemInteraction('onhover2', true)}
                    onMouseLeave={() => handleNavItemInteraction('onhover2', false)}
                  >
                    <a className="nav-item">
                      Part-Time Jobs
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /></a>
                    {/* {onhover2 && */}
                    <div className="nav-drop">
                      <a onClick={() => navigatetopostpage(1)}>Find Post & Browse Projects (PBP)</a>
                      <a onClick={() => navigatetopostpage(2)}>Search Business Opportunities (WBO)</a>
                      <a onClick={() => navigatetopostpage(3)}>Browse Part-Time Jobs (PTJ)</a>
                      <a onClick={() => navigatetopostpage(4)}>Jobs You Applied For</a>
                    </div>
                    {/* } */}
                  </li>
                  <li
                    ref={dropdownRefs.onhover4}
                    className={(isMobile ? openDropdown == 'onhover4' : onhover4) ? "active" : ""}
                    onClick={() => handleNavItemInteraction('onhover4', false)}
                    onMouseEnter={() => handleNavItemInteraction('onhover4', true)}
                    onMouseLeave={() => handleNavItemInteraction('onhover4', false)}
                  >
                    <a className="nav-item"> {t("Find OTS")}
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /></a>
                    {/* {onhover4 && */}
                    <div className="nav-drop">
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchpackaged`)}>One Time Services (OTS)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchbuyproducts`)}>Buy & Sell with Market (BSM)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchrentproducts`)}>Turn Assets to Income (TAI)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchauction`)}>Buy & Sell with Auction (BSA)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchmergersacquisitions`)}>Merger and Acquisition (MAS)</a>
                    </div>
                    {/* } */}
                  </li>
                  <li
                    ref={dropdownRefs.onhover5}
                    className={(isMobile ? openDropdown == 'onhover5' : onhover5) ? "active" : ""}
                    onClick={() => handleNavItemInteraction('onhover5', false)}
                    onMouseEnter={() => handleNavItemInteraction('onhover5', true)}
                    onMouseLeave={() => handleNavItemInteraction('onhover5', false)}
                  >
                    <a onClick={() => handleMobileNavigation(`/${lan}/searchdownloadcv`)} className="nav-item" >  {t("Recruitment")}</a>
                  </li>
                  <li
                    ref={dropdownRefs.onhover7}
                    className={(isMobile ? openDropdown == 'onhover7' : onhover7) ? "active" : ""}
                    onClick={() => handleNavItemInteraction('onhover7', false)}
                    onMouseEnter={() => handleNavItemInteraction('onhover7', true)}
                    onMouseLeave={() => handleNavItemInteraction('onhover7', false)}
                  >
                    <a className="nav-item">{t("All Services")}
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /></a>
                    {/* {onhover7 && */}
                    <div className="nav-drop">
                      <a onClick={() => navigatetopostpage(1)}>Find Post & Browse Projects (PBP)</a>
                      <a onClick={() => navigatetopostpage(2)}>Search Business Opportunities (WBO)</a>
                      <a onClick={() => navigatetopostpage(3)}>Browse Part-Time Jobs (PTJ)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchpackaged`)}>One Time Services (OTS)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchbuyproducts`)}>Buy & Sell with Market (BSM)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchrentproducts`)}>Turn Assets to Income (TAI)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchauction`)}>Buy & Sell with Auction (BSA)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchmergersacquisitions`)}>Merger and Acquisition (MAS)</a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/hireexpertsmainpage`)}>{t("Find Expert / Company")}  </a>
                      <a onClick={() => handleMobileNavigation(`/${lan}/searchdownloadcv`)}>Full Time Job (FTJ)</a>
                    </div>
                    {/* } */}
                  </li>
                </ul>
              )}
              {/* <GlobalSearch /> */}
              <div className="header-right">
                <li className="close-icon"> <button onClick={() => setmanu(false)}>  <i className="fa-solid fa-xmark"></i>  </button> </li>
                <a onClick={() => handleMobileNavigation(`/${lan}/account/calendar`)}><img src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`} /></a>
                <div ref={dropdownRefs.onhover6} className={(isMobile ? openDropdown == 'onhover6' : onhover6) ? "dropdown dropdown1 active" : "dropdown dropdown1"}>
                  <button
                    className="btn dropdown-toggle"
                    onClick={() => handleDropdownButtonClick('onhover6')}
                    onMouseEnter={() => !isMobile && setOnhover6(true)}
                    onMouseLeave={() => !isMobile && setOnhover6(false)}
                  >
                    <a> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/bell.svg`} /> <span> {notificationcount}</span></a>
                  </button>
                  {(isMobile ? openDropdown == 'onhover6' : onhover6) && (
                    <div className="dropdown-cont">
                      <Notifications
                        onhover6={isMobile ? openDropdown == 'onhover6' : onhover6}
                        setNotificationcount={setNotificationcount}
                        setOnhover6={setOnhover6} />
                    </div>
                  )}
                </div>

                <a onClick={() => handleMobileNavigation(`/${lan}/account/chats`)}>
                  <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-square.svg`} />
                  {notificationCount && notificationCount.new_chat != 0 && (
                    <span> {notificationCount.new_chat}</span>
                  )}
                </a>
                <ProfileModel
                  dropdownRefs={dropdownRefs}
                  isMobile={isMobile}
                  openDropdown={openDropdown}
                  onhover3={onhover3}
                  handleDropdownButtonClick={handleDropdownButtonClick}
                  setOnhover3={setOnhover3}
                  profile={profile}
                  isThisMobileScreen={isThisMobileScreen}
                  handleMobileNavigation={handleMobileNavigation}
                  getModalToggleHandler={getModalToggleHandler}
                  t={t}
                  lan={lan}
                />
              </div>
            </div>
          </div>
        </div>

        <LogoutModel
          modal={modal}
          getModalToggleHandler={getModalToggleHandler}
          modalContentRefs={modalContentRefs}
          LogoutMethod={LogoutMethod}
        />

        <CreateServiceModal
          createProjectModal={createProjectModal}
          getModalToggleHandler={getModalToggleHandler}
          modalContentRefs={modalContentRefs}
          NavigateToCreate={NavigateToCreate}
          setOTSroute={setOTSroute}
          setOTSAutoOpen={setOTSAutoOpen}
        />

        {whatsapp_call && (
          <a href={whatsAppHref}
            className="whatsapp-float"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp">
            <img src={whatsappIcon}
              alt="WhatsApp"
              width="60"
              height="60" />
          </a>
        )}
      </div>
    </>
  );
}